var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.867 40.2938C110.388 34.2126 105.358 27.6466 101.419 25.5711C104.228 31.1148 106.177 37.0684 107.198 43.2203L107.209 43.3179C100.756 26.9293 89.8192 20.3108 80.8815 5.91826C80.4294 5.19037 79.9774 4.46099 79.5372 3.69109C79.2854 3.25136 79.0836 2.85515 78.9084 2.49046C78.5378 1.75891 78.2522 0.985777 78.0574 0.186751C78.0576 0.14988 78.0445 0.114201 78.0207 0.086521C77.9968 0.0588407 77.9637 0.0410962 77.9278 0.0366725C77.8926 0.0268383 77.8555 0.0268383 77.8203 0.0366725C77.8129 0.0366725 77.8011 0.0501796 77.7923 0.0531811C77.7835 0.0561827 77.7643 0.0696898 77.7511 0.075693L77.7732 0.0366725C63.439 8.59116 58.5726 24.4245 58.1309 32.3486C52.4045 32.7488 46.9295 34.8989 42.42 38.5183C41.9497 38.1123 41.4582 37.7326 40.9476 37.3807C39.6474 32.7417 39.592 27.8321 40.7871 23.1638C35.5229 25.7629 30.8455 29.4475 27.0507 33.9845H27.0242C24.7626 31.0624 24.9216 21.4274 25.0512 19.4148C24.3821 19.6889 23.7434 20.0345 23.1459 20.4459C21.1493 21.8982 19.2828 23.528 17.5683 25.3159C15.6145 27.3349 13.83 29.5172 12.2336 31.8398V31.8488V31.8383C8.56511 37.1385 5.96283 43.1268 4.57698 49.4576L4.50041 49.8418C4.39292 50.3535 4.00567 52.9169 3.93941 53.4737C3.93941 53.5172 3.93058 53.5577 3.92616 53.6012C3.42664 56.2477 3.11709 58.9277 3 61.62V61.9201C3.02522 76.4756 8.40323 90.4925 18.0724 101.204C27.7415 111.915 40.9991 118.543 55.2281 119.778C69.4571 121.013 83.6234 116.767 94.9305 107.876C106.238 98.9857 113.864 86.0977 116.304 71.7563C116.4 71.0059 116.478 70.263 116.563 69.5051C117.738 59.6027 116.466 49.558 112.861 40.2848L112.867 40.2938ZM47.0935 85.8276C47.36 85.9582 47.6104 86.0993 47.8842 86.2239L47.924 86.2494C47.6472 86.1143 47.3703 85.9737 47.0935 85.8276ZM107.21 43.3344V43.2788L107.22 43.3404L107.21 43.3344Z",
    fill: "url(#paint0_linear_4962_5932)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.867 40.294C110.388 34.2128 105.358 27.6469 101.419 25.5713C104.228 31.115 106.177 37.0687 107.198 43.2205V43.2761L107.209 43.3376C111.608 56.1679 110.972 70.2349 105.433 82.5982C98.8922 96.9022 83.0665 111.563 58.2854 110.843C31.5166 110.07 7.92818 89.817 3.5256 63.2981C2.72312 59.1154 3.5256 56.9948 3.92905 53.5955C3.37872 56.2359 3.07161 58.923 3.01172 61.6217V61.9218C3.03694 76.4773 8.41494 90.4942 18.0841 101.206C27.7532 111.917 41.0108 118.544 55.2398 119.78C69.4688 121.015 83.6351 116.768 94.9422 107.878C106.249 98.9874 113.876 86.0994 116.316 71.758C116.411 71.0076 116.489 70.2647 116.575 69.5068C117.75 59.6045 116.478 49.5597 112.873 40.2865L112.867 40.294Z",
    fill: "url(#paint1_radial_4962_5932)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.867 40.294C110.388 34.2128 105.358 27.6469 101.419 25.5713C104.228 31.115 106.177 37.0687 107.198 43.2205V43.2761L107.209 43.3376C111.608 56.1679 110.972 70.2349 105.433 82.5982C98.8922 96.9022 83.0665 111.563 58.2854 110.843C31.5166 110.07 7.92818 89.817 3.5256 63.2981C2.72312 59.1154 3.5256 56.9948 3.92905 53.5955C3.37872 56.2359 3.07161 58.923 3.01172 61.6217V61.9218C3.03694 76.4773 8.41494 90.4942 18.0841 101.206C27.7532 111.917 41.0108 118.544 55.2398 119.78C69.4688 121.015 83.6351 116.768 94.9422 107.878C106.249 98.9874 113.876 86.0994 116.316 71.758C116.411 71.0076 116.489 70.2647 116.575 69.5068C117.75 59.6045 116.478 49.5597 112.873 40.2865L112.867 40.294Z",
    fill: "url(#paint2_radial_4962_5932)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1265 47.122C85.2502 47.2106 85.3651 47.2991 85.4814 47.3877C84.0479 44.7969 82.2635 42.4248 80.1806 40.3415C62.4378 22.257 75.5322 1.14093 77.7393 0.0603611L77.7614 0.0273438C63.4273 8.58183 58.5609 24.4151 58.1191 32.3393C58.7847 32.2928 59.4443 32.2357 60.1246 32.2357C65.2102 32.2458 70.2024 33.6281 74.5939 36.2423C78.9853 38.8565 82.6194 42.6092 85.1265 47.119V47.122Z",
    fill: "url(#paint3_radial_4962_5932)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1546 50.7386C60.0604 52.1854 55.0452 57.1755 53.2916 57.1755C37.0653 57.1755 34.4297 67.1812 34.4297 67.1812C35.1482 75.6067 40.9084 82.5493 47.8715 86.2112C48.1896 86.3793 48.5121 86.5309 48.8345 86.6795C49.3931 86.9316 49.9516 87.1647 50.5101 87.3788C52.8999 88.2408 55.4028 88.733 57.9356 88.8391C86.3831 90.1988 91.89 54.1709 71.3628 43.7104C76.2049 43.0683 81.1086 44.2818 85.1227 47.1157C82.6155 42.6059 78.9815 38.8532 74.59 36.239C70.1986 33.6248 65.2063 32.2424 60.1207 32.2324C59.4434 32.2324 58.7808 32.2895 58.1153 32.336C52.3889 32.7361 46.9138 34.8862 42.4044 38.5057C43.2746 39.2561 44.2567 40.2586 46.3255 42.3372C50.198 46.2258 60.1296 50.2539 60.1516 50.7266L60.1546 50.7386Z",
    fill: "url(#paint4_radial_4962_5932)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1546 50.7386C60.0604 52.1854 55.0452 57.1755 53.2916 57.1755C37.0653 57.1755 34.4297 67.1812 34.4297 67.1812C35.1482 75.6067 40.9084 82.5493 47.8715 86.2112C48.1896 86.3793 48.5121 86.5309 48.8345 86.6795C49.3931 86.9316 49.9516 87.1647 50.5101 87.3788C52.8999 88.2408 55.4028 88.733 57.9356 88.8391C86.3831 90.1988 91.89 54.1709 71.3628 43.7104C76.2049 43.0683 81.1086 44.2818 85.1227 47.1157C82.6155 42.6059 78.9815 38.8532 74.59 36.239C70.1986 33.6248 65.2063 32.2424 60.1207 32.2324C59.4434 32.2324 58.7808 32.2895 58.1153 32.336C52.3889 32.7361 46.9138 34.8862 42.4044 38.5057C43.2746 39.2561 44.2567 40.2586 46.3255 42.3372C50.198 46.2258 60.1296 50.2539 60.1516 50.7266L60.1546 50.7386Z",
    fill: "url(#paint5_radial_4962_5932)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7462 36.587C40.2086 36.8872 40.5899 37.1483 40.9242 37.3839C39.624 32.7449 39.5686 27.8353 40.7637 23.167C35.4995 25.7661 30.8221 29.4507 27.0273 33.9877C27.3056 33.9802 35.5837 33.8286 39.7462 36.587Z",
    fill: "url(#paint6_radial_4962_5932)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51567 63.301C7.91972 89.8199 31.5066 110.081 58.2755 110.846C83.0566 111.56 98.8853 96.8976 105.423 82.6011C110.962 70.2378 111.598 56.1708 107.199 43.3405V43.285C107.199 43.2415 107.19 43.216 107.199 43.2295L107.209 43.327C109.234 56.7996 102.51 69.8459 91.9987 78.6856L91.9663 78.7606C71.4847 95.7645 51.8866 89.017 47.9258 86.2645C47.6489 86.1295 47.3721 85.9889 47.0953 85.8428C35.1553 80.0258 30.2212 68.944 31.2814 59.429C28.4471 59.4716 25.6615 58.6755 23.2621 57.1372C20.8627 55.5989 18.9525 53.3844 17.7629 50.7619C20.8975 48.8048 24.4715 47.6984 28.1444 47.5481C31.8173 47.3979 35.4668 48.2087 38.7451 49.9035C45.5026 53.0298 53.1917 53.3379 60.1691 50.7619C60.147 50.2892 50.2154 46.2596 46.3429 42.3725C44.2741 40.2939 43.292 39.2929 42.4218 38.541C41.9515 38.135 41.46 37.7552 40.9494 37.4034C40.6107 37.1678 40.2294 36.9127 39.7714 36.6065C35.6088 33.8481 27.3308 33.9996 27.0569 34.0071H27.0304C24.7688 31.0851 24.9278 21.4501 25.0574 19.4375C24.3883 19.7116 23.7496 20.0572 23.1521 20.4685C21.1555 21.9209 19.289 23.5506 17.5745 25.3386C15.6137 27.3519 13.8218 29.5292 12.2178 31.8475V31.8565V31.846C8.54923 37.1462 5.94695 43.1345 4.56109 49.4652C4.53312 49.5838 2.50558 58.6185 3.50536 63.304L3.51567 63.301Z",
    fill: "url(#paint7_radial_4962_5932)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1793 40.338C82.2627 42.4236 84.0472 44.7983 85.4801 47.3917C85.7937 47.6333 86.0867 47.8735 86.3356 48.1061C99.2739 60.2625 92.4948 77.4465 91.9897 78.6621C102.5 69.836 109.217 56.7806 107.2 43.3036C100.745 26.9 89.7958 20.2815 80.8728 5.88896C80.4208 5.16108 79.9688 4.43169 79.5285 3.66179C79.2767 3.22206 79.075 2.82585 78.8998 2.46116C78.5291 1.72961 78.2435 0.95648 78.0487 0.157454C78.049 0.120583 78.0359 0.0849044 78.012 0.0572241C77.9881 0.0295438 77.955 0.0117993 77.9191 0.00737562C77.884 -0.00245854 77.8468 -0.00245854 77.8116 0.00737562C77.8043 0.00737562 77.7925 0.0208827 77.7837 0.0238843C77.7748 0.0268858 77.7557 0.0403929 77.7424 0.0463961C75.5353 1.11346 62.4438 22.243 80.1867 40.3125L80.1793 40.338Z",
    fill: "url(#paint8_radial_4962_5932)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3345 48.1128C86.0857 47.8802 85.7927 47.64 85.479 47.3984C85.3627 47.3099 85.2479 47.2213 85.1242 47.1328C81.1101 44.2988 76.2064 43.0853 71.3643 43.7275C91.89 54.188 86.3831 90.2068 57.9371 88.8561C55.4043 88.75 52.9014 88.2578 50.5116 87.3959C49.9531 87.1828 49.3946 86.9496 48.836 86.6965C48.5136 86.5464 48.1911 86.3964 47.873 86.2283L47.9128 86.2538C51.8795 89.0137 71.4718 95.7568 91.9533 78.7498L91.9857 78.6748C92.4967 77.4592 99.2757 60.2752 86.3316 48.1188L86.3345 48.1128Z",
    fill: "url(#paint9_radial_4962_5932)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4312 67.1721C34.4312 67.1721 37.0654 57.1664 53.2931 57.1664C55.0468 57.1664 60.0663 52.1762 60.1561 50.7295C53.1788 53.3055 45.4896 52.9974 38.7322 49.871C35.4539 48.1763 31.8044 47.3654 28.1314 47.5157C24.4585 47.666 20.8845 48.7724 17.75 50.7295C18.9396 53.3519 20.8498 55.5665 23.2492 57.1048C25.6486 58.6431 28.4341 59.4392 31.2684 59.3965C30.2112 68.907 35.1439 79.9873 47.0824 85.8104C47.3489 85.9409 47.5992 86.082 47.8731 86.2066C40.904 82.5372 35.1498 75.5975 34.4312 67.1766V67.1721Z",
    fill: "url(#paint10_radial_4962_5932)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.867 40.2938C110.388 34.2126 105.358 27.6466 101.419 25.5711C104.228 31.1148 106.177 37.0684 107.198 43.2203L107.209 43.3179C100.756 26.9293 89.8191 20.3108 80.8815 5.91826C80.4294 5.19037 79.9774 4.46099 79.5371 3.69109C79.2854 3.25136 79.0836 2.85515 78.9084 2.49046C78.5378 1.75891 78.2522 0.985777 78.0573 0.186751C78.0576 0.14988 78.0445 0.114201 78.0206 0.086521C77.9967 0.0588407 77.9637 0.0410962 77.9278 0.0366725C77.8926 0.0268383 77.8555 0.0268383 77.8203 0.0366725C77.8129 0.0366725 77.8011 0.0501796 77.7923 0.0531811C77.7835 0.0561827 77.7643 0.0696898 77.7511 0.0756929L77.7732 0.0366725C63.439 8.59116 58.5726 24.4245 58.1309 32.3486C58.7964 32.3021 59.4561 32.2451 60.1363 32.2451C65.2219 32.2551 70.2142 33.6375 74.6056 36.2516C78.9971 38.8658 82.6311 42.6185 85.1383 47.1284C81.1242 44.2944 76.2206 43.0809 71.3784 43.7231C91.9041 54.1836 86.3972 90.2024 57.9512 88.8517C55.4184 88.7456 52.9155 88.2534 50.5258 87.3915C49.9672 87.1784 49.4087 86.9452 48.8501 86.6921C48.5277 86.542 48.2052 86.3919 47.8872 86.2238L47.9269 86.2494C47.6501 86.1143 47.3733 85.9737 47.0965 85.8276C47.363 85.9582 47.6133 86.0993 47.8872 86.2238C40.9181 82.5529 35.1638 75.6133 34.4453 67.1939C34.4453 67.1939 37.0795 57.1881 53.3072 57.1881C55.0609 57.1881 60.0804 52.198 60.1702 50.7513C60.1481 50.2785 50.2165 46.2489 46.344 42.3619C44.2753 40.2833 43.2932 39.2822 42.423 38.5303C41.9527 38.1243 41.4611 37.7446 40.9505 37.3928C39.6503 32.7537 39.5949 27.8441 40.79 23.1758C35.5259 25.7749 30.8484 29.4595 27.0537 33.9965H27.0272C24.7655 31.0744 24.9245 21.4394 25.0541 19.4268C24.385 19.7009 23.7464 20.0465 23.1488 20.4579C21.1522 21.9102 19.2857 23.54 17.5712 25.3279C15.6174 27.3469 13.833 29.5292 12.2366 31.8518V31.8609V31.8503C8.56804 37.1506 5.96576 43.1388 4.57991 49.4696L4.50334 49.8538C4.39585 50.3656 3.91437 52.9649 3.84516 53.5232C3.40476 56.2064 3.1235 58.9142 3.00293 61.632V61.9321C3.02815 76.4876 8.40616 90.5045 18.0753 101.216C27.7444 111.927 41.0021 118.555 55.231 119.79C69.46 121.025 83.6263 116.779 94.9334 107.888C106.241 98.9977 113.867 86.1097 116.307 71.7683C116.402 71.0179 116.481 70.275 116.566 69.5171C117.741 59.6147 116.469 49.57 112.864 40.2968L112.867 40.2938ZM107.206 43.2818L107.216 43.3434L107.206 43.2818Z",
    fill: "url(#paint11_linear_4962_5932)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4962_5932",
    x1: 105.314,
    y1: 18.6163,
    x2: 8.83189,
    y2: 109.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.647 13.535) scale(118.973 121.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4741 63.0609) scale(118.973 121.264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1986 -13.4797) scale(86.1816 87.841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2229 94.5766) scale(56.6446 57.7353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.229 52.6506) rotate(-13.8433) scale(30.07 35.8055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0019 9.03258) scale(40.757 41.5418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3956 -17.9816) scale(173.895 177.243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.9421 -8.1554) rotate(84.089) scale(129.859 83.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0024 24.0402) scale(108.548 110.638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4962_5932",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.9786 30.0426) scale(118.811 121.098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4962_5932",
    x1: 104.165,
    y1: 18.121,
    x2: 22.0267,
    y2: 98.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.7ea37e91277087b04c190c867638cc1a.svg";
export { ForwardRef as ReactComponent };